import { 
  getCoboltojavaApi,
  getdb2sqltotsqlApi, 
  getBteqtopysparkApi, 
  getCpptorustApi, 
  getctorustApi, 
  getPytocppApi, 
  getcpptogoApi, 
  getPhptonodejsApi, 
  getdnettoflaskApi, 
  getsqlservertomysqlApi,
  getreacttoangularApi,
  gettftopytorchApi,
  getETLTooltoDatapipelineApi,
  getCOBOLtoSQLApi,
  getPLSQLtoPythonApi,
  getPostgreSQLtoMSAccessApi,
  getOracletoPostgreSQLApi,
  getAssemblytoCApi,
  getCtoEmbeddedCApi,
  getXamarinToKotlinApi,
  getHadoopToSparkApi,
  getJavaToAngularApi,
  getJenkinsToAzurePipelinesApi,
  getCircleCIToGitLabCIApi,
  getPerlToPHPApi,
  getRailsToDjangoApi,
  getGoogleCloudToAWSApi,
  getAWSLambdaToAzureFunctionsApi,
  getMicrosoftDynamicsToNetSuiteApi
} from "../../end-points/caseScenarios";

export const conversionOptions = [
  {
    value: "cobol-java",
    label: "COBOL to Java",
    action: "getCoboltojava",
    api: getCoboltojavaApi
  },
  {
    value: "db2sql-tsql",
    label: "DB2 SQL to T-SQL",
    action: "getdb2sqltotsql",
    api: getdb2sqltotsqlApi
  },
  {
    value: "bteq-pyspark",
    label: "BTEQ to Pyspark",
    action: "getBteqtopyspark",
    api: getBteqtopysparkApi
  },
  {
    value: "c++-rust",
    label: "C++ to Rust",
    action: "getCpptorust",
    api: getCpptorustApi
  },
  {
    value: "c-rust",
    label: "C to Rust",
    action: "getctorust",
    api: getctorustApi
  },
  {
    value: "python-c++",
    label: "Python to C++",
    action: "getPytocpp",
    api: getPytocppApi
  },
  {
    value: "c++-go",
    label: "C++ to Go",
    action: "getcpptogo",
    api: getcpptogoApi
  },
  {
    value: "php-nodejs",
    label: "Php to Nodejs",
    action: "getPhptonodejs",
    api: getPhptonodejsApi
  },
  {
    value: ".Net-flask",
    label: ".Net to Flask",
    action: "getdnettoflask",
    api: getdnettoflaskApi
  },
  {
    value: "sqlServer-mySql",
    label: "Sql server to My Sql",
    action: "getsqlservertomysql",
    api: getsqlservertomysqlApi
  },
  {
    value: "React-angular",
    label: "React to Angular",
    action: "getreacttoangular",
    api: getreacttoangularApi
  },
  {
    value: "TensorFlow-pytorch",
    label: "TensorFlow to PyTorch",
    action: "gettftopytorch",
    api: gettftopytorchApi
  },
  {
    value: "ETLTool-Datapipeline",
    label: "ETL Tools to Datapipelines",
    action: "getETLTooltoDatapipeline",
    api: getETLTooltoDatapipelineApi
  },
  {
    value: "COBOL-SQL",
    label: "COBOL to SQL",
    action: "getCOBOLtoSQL",
    api: getCOBOLtoSQLApi
  },
  {
    value: "PL SQL-Python",
    label: "PL SQL to Python",
    action: "getPLSQLtoPython",
    api: getPLSQLtoPythonApi
  },
  {
    value: "PostgreSQL-MSAccess",
    label: "PostgreSQL to MSAccess",
    action: "getPostgreSQLtoMSAccess",
    api: getPostgreSQLtoMSAccessApi
  },
  {
    value: "Oracle-PostgreSQL",
    label: "Oracle to PostgreSQL",
    action: "getOracletoPostgreSQL",
    api: getOracletoPostgreSQLApi
  },
  {
    value: "Assemblyt-C",
    label: "Assemblyt to C",
    action: "getAssemblytoC",
    api: getAssemblytoCApi
  },
  {
    value: "C-EmbeddedC",
    label: "C to Embedded C",
    action: "getCtoEmbeddedC",
    api: getCtoEmbeddedCApi
  },
  {
    value: "Xamarin-Kotlin",
    label: "Xamarin to Kotlin",
    action: "getXamarinToKotlin",
    api: getXamarinToKotlinApi
  },
  {
    value: "Hadoop-Spark",
    label: "Hadoop to Spark",
    action: "getHadoopToSpark",
    api: getHadoopToSparkApi
  },
  {
    value: "Java-Angular",
    label: "Java to Angular",
    action: "getJavaToAngular",
    api: getJavaToAngularApi
  },
  {
    value: "Jenkins-AzurePipelines",
    label: "Jenkins to AzurePipelines",
    action: "getJenkinsToAzurePipelines",
    api: getJenkinsToAzurePipelinesApi
  },
  {
    value: "CircleCI-GitLabCI",
    label: "CircleCI to GitLabCI",
    action: "getCircleCIToGitLabCI",
    api: getCircleCIToGitLabCIApi
  },
  {
    value: "Perl-PHP",
    label: "Perl to PHP",
    action: "getPerlToPHP",
    api: getPerlToPHPApi
  },
  {
    value: "Rails-Django",
    label: "Rails to Django",
    action: "getRailsToDjango",
    api: getRailsToDjangoApi
  },
  {
    value: "GoogleCloud-AWS",
    label: "GoogleCloud to AWS",
    action: "getGoogleCloudToAWS",
    api: getGoogleCloudToAWSApi
  },
  {
    value: "AWSLambda-AzureFunctions",
    label: "AWSLambda to AzureFunctions",
    action: "getAWSLambdaToAzureFunctions",
    api: getAWSLambdaToAzureFunctionsApi
  },
  {
    value: "MicrosoftDynamics-NetSuite",
    label: "MicrosoftDynamics to NetSuite",
    action: "getMicrosoftDynamicsToNetSuite",
    api: getMicrosoftDynamicsToNetSuiteApi
  }
];

